import { createAsyncThunk } from '@reduxjs/toolkit'
import { toastr } from 'react-redux-toastr'

import * as api from 'connections/restApi'

export const post = createAsyncThunk(
  'move/post',
  async (params, { rejectWithValue }) => {
    try {
      await api.move(params)
      return { success: true }
    } catch (error) {
      console.log('error', error)
      toastr.error('', error.Message)
      return rejectWithValue(error.Message)
    }
  }
)
